import React from 'react';
import { Layout, Menu, Icon, Drawer } from 'antd';
import { withRouter } from 'react-router-dom';
import * as item from './MenuItems'
import { getNavOpenKeys, getNavSelectedKey } from '../../utilities/nav'

import './index.css'

const { Sider } = Layout;

const navMenu = (user, location) => {
  const selectedKey = getNavSelectedKey(location.pathname)
  const openKeys = getNavOpenKeys(location.pathname)

  return (
    <div>
      <div className="logo"><img src={"/nav_logo_white.png"} alt="My logo" style={{ height: '100%', paddingLeft: '56px', marginTop: '3px' }} /></div>
      <Menu
        theme='dark'
        mode="inline"
        selectedKeys={[selectedKey]}
        defaultOpenKeys={openKeys}
        style={{ borderTop: '#b3b3b333 solid 1px' }}
      >
        {item.Home(user.role)}
        {item.Outline(user.role)}
        {item.Bores(user.role)}
        {item.Calendar(user.role)}
        {item.Timesheet(user.role)}
        {item.Maintenance(user.role)}
        {item.Prestarts(user.role)}
        {item.Fulcrum(user.role)}
        {item.Misc(user)}

        {item.Role(user.role)}
        {item.Username(user.username)}
        {item.Logout(user.role)}
      </Menu>
    </div>
  )
}

export class Navigation extends React.Component {
  render() {
    return (
      <Sider
        collapsedWidth="0"
        style={{ minHeight: "100vh" }}
        id="layoutSider"
        theme='dark'
        className='printHide'
      >
        {navMenu(this.props.user, this.props.location)}
      </Sider>
    )
  }
}

export const NavigationWithRouter = withRouter(Navigation)

export class NavigationSmaller extends React.Component {
  state = {
    visible: false,
    left: '0'
  };
  showDrawer = () => {
    this.setState({
      visible: true,
      left: '200px'
    });
  };
  onClose = () => {
    this.setState({
      visible: false,
      left: '0'
    });
  };
  render() {
    return (
      <div className='printHide'>
        <Drawer
          placement="left"
          closable={false}
          className='navDrawer'
          onClose={this.onClose}
          visible={this.state.visible}
          style={{ maxWidth: '200px', animationDuration: '0s !important' }}
        >
          {navMenu(this.props.user, this.props.location)}
        </Drawer>
        <div style={{ background: '#021429', width: '36px', padding: '10px', position: 'fixed', margin: '10px 0', borderRadius: '0 5px 5px 0', left: this.state.left, top: '5px', zIndex: 1 }} onClick={this.showDrawer}>
          <Icon type="bars" style={{ color: 'white' }} />
        </div>
      </div>
    )
  }
}

export const NavigationSmallerWithRouter = withRouter(NavigationSmaller)
